import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0179d8e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","width":"100%"} }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  key: 0,
  style: {"position":"absolute","left":"115px","top":"-3px","color":"red"}
}

import { computed, reactive, Ref, ref, watch } from "vue";
import { getComponentUiText, IsPhoneNumber } from "@/utils/utilities";
import WizardInputQuestion from "./wizardInputQuestion.vue";
import MoreDetails from "./moreDetails.vue";

import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import store from "@/store";
import {
  INPUT_TYPE,
  WIZARD_STATE_NAME,
  WIZARD_STATE_PAGE,
  WIZARD_STATE_SITES_TYPE_ID,
  idWizardPage as idPage,
  statusPage,
} from "@/utils/constants";
import WizardDropdown from "./wizardDropdown.vue";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import WizardMultiLevelMultiSelectQuestion from "./wizardMultiLevelMultiSelectQuestion.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'listSite',
  props: {
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: [
  "onUpdate",
  "update:answer",
  "changeStatusAddTeams",
  "updateCollapse",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;


const currentOrg = computed(() => store.state.Org.currentOrg);


const item = ref(props.data.item);

watch(
  () => props.data.item,
  (newValue) => {
    item.value = props.data.item;
  },
  { immediate: true },
);

const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find((i) => i.id === item.value.id)
  );
});

const statusInPageClone = ref(bodyAPIError);
const isValidForm: Ref<string> = ref("");

const questionSectionValue = computed(() => {
  const data = store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.SITES,
    currentOrg.value.id || null,
  );
  return data ? data[0].types : [];
});
const updateStore = (item, fieldDelete?) => {
  if (fieldDelete && statusInPageClone.value) {
    delete statusInPageClone.value[fieldDelete];
    if (
      statusInPageClone.value &&
      Object.keys(statusInPageClone.value).length === 1 &&
      // eslint-disable-next-line
      statusInPageClone.value.hasOwnProperty("id")
    ) {
      delete statusInPageClone.value.id;
    }
  }
  if (item.name && item.name.length) {
    if (!item?.typeId || !item?.legalTypeId || !item?.siteAttributes.length) {
      item.isCollapse = true;
    }
  }
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    namePage: WIZARD_STATE_PAGE.SITES,
    currentOrg: currentOrg.value.id,
    isSelected: true,
    isSelectedPage: "isSelectedSites",
  });
};

const updateAccordion = (isCollapse) => {
  emits("updateCollapse", { collapse: isCollapse, index: props.data.index });
};

const dropdownCountryData = computed(() => {
  return questionSectionValue.value.find((item) => item.typeId === "country")
    ?.typeValues;
});

const dropdownSitesTypeData = computed(() => {
  return questionSectionValue.value.find(
    (item) => item.typeId === WIZARD_STATE_SITES_TYPE_ID.SITE_TYPE,
  )?.typeValues;
});

const dropdownLegalTypeData = computed(() => {
  return questionSectionValue.value.find(
    (item) => item.typeId === WIZARD_STATE_SITES_TYPE_ID.SITE_LEGAL_TYPE,
  )?.typeValues;
});

const getDropdownAttributeTypeData = (value) => {
  return questionSectionValue.value
    .find(
      (item) => item.typeId === WIZARD_STATE_SITES_TYPE_ID.SITE_ATTRIBUTE_TYPE,
    )
    ?.typeValues.map((item: any) => ({
      ...item,
      title: item?.name || "",
      selected:
        value?.findIndex((site) => site.attributeTypeId === item.id) !== -1,
    }));
};

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  typeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  legalTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  siteAttributes: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  phoneNumber: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      IsPhoneNumber,
    ),
  },
};
let v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  const isValid = !v$.value.$errors || v$.value.$errors.length === 0;
  if (!isValid) {
    isValidForm.value = "1";
  }
  return { isValid };
};
__expose({
  saveChanges,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WizardDetailWrapper, {
    title: 
      _unref(getComponentUiText)(
        'app-menu-submenu-home-setup-wizard-sites-wrapper-question-title-1',
      )
    ,
    "show-accordion": item.value.isCollapse,
    data: __props.data,
    validation: _unref(v$).name,
    class: _normalizeClass(['tw-mb-[25px]']),
    "page-active": _unref(idPage).sitesPage,
    "is-api-error": statusInPageClone.value,
    "onUpdate:accordion": updateAccordion
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.name) = $event)),
          class: "enter__name tw-flex-1 tw-text-[#211F58] tw-text-[14px] tw-not-italic tw-font-[600] tw-leading-[100%] input",
          placeholder: 
            _unref(getComponentUiText)(
              'app-menu-submenu-home-setup-wizard-sites-name-title-1',
            )
          ,
          style: {"border":"unset","background-color":"unset"},
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          onInput: _cache[2] || (_cache[2] = ($event: any) => (updateStore(item.value, 'name')))
        }, null, 40, _hoisted_2), [
          [_vModelText, item.value.name]
        ]),
        (!item.value.name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([
        'tw-flex tw-flex-col tw-gap-[20px]',
        item.value.showMoreDetail ? 'tw-rounded-b-none tw-pb-[25px]' : '',
      ])
      }, [
        _createVNode(WizardDropdown, {
          id: `typeId`,
          modelValue: item.value.typeId,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((item.value.typeId) = $event)),
            _cache[4] || (_cache[4] = ($event: any) => (updateStore(item.value, 'typeId')))
          ],
          validation: _unref(v$).typeId,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-site-type-title-1',
          )
        ,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-prompt-2',
          )
        ,
          "is-api-error": statusInPageClone.value && item.value.id && statusInPageClone.value.typeId,
          required: true,
          data: dropdownSitesTypeData.value
        }, null, 8, ["modelValue", "validation", "title", "placeholder", "is-api-error", "data"]),
        _createVNode(WizardDropdown, {
          id: `legalTypeId`,
          modelValue: item.value.legalTypeId,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((item.value.legalTypeId) = $event)),
            _cache[6] || (_cache[6] = ($event: any) => (updateStore(item.value, 'legalTypeId')))
          ],
          validation: _unref(v$).legalTypeId,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.legalTypeId
        ,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-site-legal-type-title-1',
          )
        ,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-prompt-2',
          )
        ,
          required: true,
          data: dropdownLegalTypeData.value
        }, null, 8, ["modelValue", "validation", "is-api-error", "title", "placeholder", "data"]),
        _createVNode(WizardMultiLevelMultiSelectQuestion, {
          id: `siteAttributes`,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-site-attribute-type-title-1',
          )
        ,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.siteAttributes
        ,
          validation: _unref(v$).siteAttributes,
          required: true,
          "dropdown-data": getDropdownAttributeTypeData(item.value.siteAttributes),
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-prompt-2',
          )
        ,
          "search-placeholder": _unref(getComponentUiText)('app-header-search-prompt-1'),
          "onUpdate:store": _cache[7] || (_cache[7] = ($event: any) => (updateStore(item.value, 'siteAttributes'))),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = 
          (value, data) =>
            (item.value.siteAttributes = data?.map((item) => {
              return { attributeTypeId: item.id };
            }))
        )
        }, null, 8, ["title", "is-api-error", "validation", "dropdown-data", "placeholder", "search-placeholder"])
      ], 2),
      _createVNode(MoreDetails, {
        "classes-more-detail": '!tw-p-0',
        "is-show-questions": false,
        "is-details": item.value.id || isValidForm.value,
        "is-details-validate": item.value.showMoreDetail,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (item.value.showMoreDetail = $event))
      }, null, 8, ["is-details", "is-details-validate"]),
      _createElementVNode("div", {
        class: _normalizeClass([
        'more-detail-container tw-flex tw-flex-col tw-gap-[20px]',
        item.value.showMoreDetail ? 'show' : '',
      ])
      }, [
        _createVNode(WizardDropdown, {
          id: `country`,
          modelValue: item.value.countryId,
          "onUpdate:modelValue": [
            _cache[10] || (_cache[10] = ($event: any) => ((item.value.countryId) = $event)),
            _cache[11] || (_cache[11] = ($event: any) => (updateStore(item.value, 'countryId')))
          ],
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-country-title-1',
          )
        ,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-country-1',
          )
        ,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.countryId
        ,
          data: dropdownCountryData.value,
          "use-visual-scroll": true
        }, null, 8, ["modelValue", "title", "placeholder", "is-api-error", "data"]),
        _createVNode(WizardInputQuestion, {
          "model-value": item.value.startDate,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.startDate
        ,
          type: _unref(INPUT_TYPE).Date,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-date-moved-title-1',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)('app-menu-submenu-home-setup-wizard-sites-date-1')
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:modelValue": _cache[12] || (_cache[12] = (value) => (item.value.startDate = value)),
          "onUpdate:store": _cache[13] || (_cache[13] = ($event: any) => (updateStore(item.value, 'startDate')))
        }, null, 8, ["model-value", "is-api-error", "type", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.address1,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((item.value.address1) = $event)),
          type: _unref(INPUT_TYPE).Text,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.address1
        ,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-address-title-1',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-address-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[15] || (_cache[15] = ($event: any) => (updateStore(item.value, 'address1')))
        }, null, 8, ["modelValue", "type", "is-api-error", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.address2,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((item.value.address2) = $event)),
          type: _unref(INPUT_TYPE).Text,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.address2
        ,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-address-title-2',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-address-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[17] || (_cache[17] = ($event: any) => (updateStore(item.value, 'address2')))
        }, null, 8, ["modelValue", "type", "is-api-error", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.address3,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((item.value.address3) = $event)),
          type: _unref(INPUT_TYPE).Text,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.address3
        ,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-address-title-3',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-address-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[19] || (_cache[19] = ($event: any) => (updateStore(item.value, 'address3')))
        }, null, 8, ["modelValue", "type", "is-api-error", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.townCity,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((item.value.townCity) = $event)),
          type: _unref(INPUT_TYPE).Text,
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.townCity
        ,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-town-city-title-1',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-town-city-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[21] || (_cache[21] = ($event: any) => (updateStore(item.value, 'townCity')))
        }, null, 8, ["modelValue", "type", "is-api-error", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.postcode,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((item.value.postcode) = $event)),
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.postcode
        ,
          type: _unref(INPUT_TYPE).Text,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-modal-sites-questions-post-code-title-1',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-postcode-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[23] || (_cache[23] = ($event: any) => (updateStore(item.value, 'postcode')))
        }, null, 8, ["modelValue", "is-api-error", "type", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.phoneNumber,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((item.value.phoneNumber) = $event)),
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.phoneNumber
        ,
          type: _unref(INPUT_TYPE).Text,
          validation: _unref(v$).phoneNumber,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-phone-number-1',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-phone-number-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[25] || (_cache[25] = ($event: any) => (updateStore(item.value, 'phoneNumber')))
        }, null, 8, ["modelValue", "is-api-error", "type", "validation", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.details,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((item.value.details) = $event)),
          "is-api-error": 
          statusInPageClone.value && item.value.id && statusInPageClone.value.details
        ,
          type: _unref(INPUT_TYPE).TextArea,
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-other-details-1',
          )
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-other-details-1',
          )
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[27] || (_cache[27] = ($event: any) => (updateStore(item.value, 'details')))
        }, null, 8, ["modelValue", "is-api-error", "type", "title", "placeholder"]),
        _createVNode(WizardInputQuestion, {
          modelValue: item.value.notes,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((item.value.notes) = $event)),
          type: _unref(INPUT_TYPE).TextArea,
          "is-api-error": statusInPageClone.value && item.value.id && statusInPageClone.value.notes,
          title: 
          _unref(getComponentUiText)('app-menu-submenu-home-setup-wizard-sites-notes-1')
        ,
          required: false,
          placeholder: 
          _unref(getComponentUiText)('app-menu-submenu-home-setup-wizard-sites-notes-1')
        ,
          "class-title": 'tw-text-[14px] !tw-leading-[100%]',
          "onUpdate:store": _cache[29] || (_cache[29] = ($event: any) => (updateStore(item.value, 'notes')))
        }, null, 8, ["modelValue", "type", "is-api-error", "title", "placeholder"])
      ], 2)
    ]),
    _: 1
  }, 8, ["title", "show-accordion", "data", "validation", "page-active", "is-api-error"]))
}
}

})